
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"22","fill":"none","stroke":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.5 5.444c0 .88-.264 1.739-.758 2.47a4.489 4.489 0 01-2.02 1.637 4.552 4.552 0 01-2.6.252 4.518 4.518 0 01-2.304-1.216 4.428 4.428 0 01-1.232-2.275 4.393 4.393 0 01.257-2.568A4.457 4.457 0 017.5 1.749a4.54 4.54 0 015.682.553A4.417 4.417 0 0114.5 5.444zm0 8.89h-9a4.529 4.529 0 00-3.182 1.301A4.417 4.417 0 001 18.778v0c0 .59.237 1.154.659 1.571.422.417.994.651 1.591.651h13.5c.597 0 1.169-.234 1.591-.65.422-.418.659-.983.659-1.572 0-1.179-.474-2.31-1.318-3.143a4.529 4.529 0 00-3.182-1.302v0z","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    